import Theme from 'Theme/index';

export default {
    PIXELS_PER_MIN: 10,
    currentTimeUpdateInterval: 60,
    grid: {
        backgroundColor: 'rgba(255,255,255,0.03)'
    },
    datePicker: {
        toggler: {
            container: {
                backgroundColor: 'transparent',
                height: 24
            },
            text: {
                color: Theme.primaryTextColor,
                fontSize: Theme.primaryFontSize,
                width: '100%',
                textAlign: 'center'
            }
        },
        window: {
            container: {
                backgroundColor: '#fff'
            },
            line: {
                backgroundColor: '#fff',
                flexDirection: 'column',
                height: 70,
                justifyContent: 'center',
                paddingHorizontal: 18,
                width: 100
            },
            activeLine: {
                backgroundColor: '#4b4b4b'
            },
            cellDOW: {
                color: '#6C6C6C',
                fontSize: 30,
                fontWeight: '300',
                textAlign: 'center',
                width: '100%'
            },
            lineText: {
                color: '#6C6C6C',
                fontSize: 15,
                fontWeight: '300',
                width: '100%',
                textAlign: 'center'
            },
            lineTextActive: {
                color: Theme.primaryTextColor
            }
        }
    },
    cell: {
        container: {
            backgroundColor: 'transparent',
            borderColor: 'rgba(255,255,255,0.2)',
            height: 71,
            paddingHorizontal: 17
        },
        titleContainerWithIcon: {
            flexDirection: 'row',
            overflow: 'hidden'
        },
        activeContainer: {
            backgroundColor: 'rgba(255,255,255,0.13)',
            borderColor: 'rgba(255,255,255,0.1)'
        },
        selectedContainer: {
            backgroundColor: Theme.primaryActiveColor
        },
        title: {
            fontFamily: Theme.regularFont,
            fontWeight: 'normal',
            fontSize: 21,
            color: '#EBEBEB'
        },
        focusedTitle: {
            fontFamily: Theme.regularFont,
            fontWeight: '500',
            fontSize: 21,
            color: Theme.primaryTextColor
        },
        lockedTitle: {
            color: '#7d7d7d'
        },
        description: {
            color: Theme.secondaryTextColor,
            fontFamily: Theme.regularFont,
            fontSize: 15,
            fontWeight: 'normal'
        },
        focusedDescription: {
            color: Theme.primaryTextColor,
            fontSize: 15,
            fontWeight: '500'
        },
        icon: {
            marginTop: 2,
            marginLeft: 5,
            width: 21,
            height: 21
        }
    },
    sidebar: {
        container: {
            width: 144,
            backgroundColor: '#262626CC'
        },
        logo: {
            width: 70,
            height: 40
        }
    },
    timeline: {
        container: {
            backgroundColor: '#172324',
            borderBottomWidth: 1,
            borderStyle: 'solid',
            borderBottomColor: 'rgba(255,255,255,0.2)',
            height: 48
        },
        text: {
            color: Theme.secondaryTextColor,
            fontFamily: Theme.regularFont,
            fontWeight: '100',
            fontSize: 18
        }
    },
    currentTime: {
        line: {
            backgroundColor: Theme.primaryActiveColor,
            width: 1
        },
        label: {
            backgroundColor: Theme.primaryActiveColor,
            borderRadius: 3,
            height: '50%',
            width: 58
        },
        labelText: {
            color: Theme.primaryTextColor,
            fontFamily: Theme.regularFont,
            fontSize: 15,
            fontWeight: '500',
            textAlign: 'center',
            width: '100%'
        }
    }
};
